// data.js
const delegateData = [
    {
      "name": "Gabriel Acevero",
      "img": "https://mgaleg.maryland.gov/2023RS/images/acevero01.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/acevero01",
      "party": "D",
      "district": "39",
      "committee": "APP",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "E"
      },
      "2023 Score": "100%",
      "Life time Score": "95%"
    },
    {
      "name": "Christopher Adams",
      "img": "https://mgaleg.maryland.gov/2023RS/images/adams01.jpg",
      "contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/adams01",
      "party": "R",
      "district": "37B",
      "committee": "ECM",
      "votes": {
        "Transit Equity": "-",
        "Comprehensive Flood Management": "-",
        "Greenspace Equity": "-",
        "Offshore Wind": "-",
        "LMI Energy Efficiency": "-",
        "Community Solar": "-",
        "Clean Trucks Act": "-",
        "Clean Transportation and Energy": "-",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "20%",
      "Life time Score": "15%"
    },
    {
      "name": "Jackie Addison",
      "img": "https://mgaleg.maryland.gov/2023RS/images/addison01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/addison01",
      "party": "D",
      "district": "45",
      "committee": "ENT",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "100%"
    },
    {
      "name": "Nick Allen",
      "img": "https://mgaleg.maryland.gov/2023RS/images/allen01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/allen01",
      "party": "D",
      "district": "8",
      "committee": "ENT",
      "votes": {
        "Transit Equity": "+",
        "Comprehensive Flood Management": "+",
        "Greenspace Equity": "+",
        "Offshore Wind": "+",
        "LMI Energy Efficiency": "+",
        "Community Solar": "+",
        "Clean Trucks Act": "+",
        "Clean Transportation and Energy": "+",
        "Maryland the Beautiful": "+",
        "Forest Conservation Act": "+"
      },
      "2023 Score": "100%",
      "Life time Score": "100%"
    },
    {
        "name": "Tiffany Alston",
        "img": "https://mgaleg.maryland.gov/2023RS/images/alston01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/alston01",
        "party": "D",
        "district": "24",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Marlon Amprey",
        "img": "https://mgaleg.maryland.gov/2023RS/images/amprey01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/amprey01",
        "party": "D",
        "district": "40",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Carl Anderton",
        "img": "https://mgaleg.maryland.gov/2023RS/images/anderton01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/anderton01",
        "party": "R",
        "district": "38B",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "+",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "70%",
        "Life time Score": "56%"
      },
      {
        "name": "Steve Arentz",
        "img": "https://mgaleg.maryland.gov/2023RS/images/arentz01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/arentz01",
        "party": "R",
        "district": "36",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "14%"
      },
      {
        "name": "Lauren Arikan",
        "img": "https://mgaleg.maryland.gov/2023RS/images/arikan01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/arikan01",
        "party": "R",
        "district": "7B",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "-",
          "Forest Conservation Act": "-"
        },
        "2023 Score": "0%",
        "Life time Score": "16%"
      },
      {
        "name": "Dalya Attar",
        "img": "https://mgaleg.maryland.gov/2023RS/images/attar01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/attar01",
        "party": "D",
        "district": "41",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Vanessa Atterbeary",
        "img": "https://mgaleg.maryland.gov/2023RS/images/atterbeary01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/atterbeary01",
        "party": "D",
        "district": "13",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "E",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Heather Bagnall",
        "img": "https://mgaleg.maryland.gov/2023RS/images/bagnall01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/bagnall01",
        "party": "D",
        "district": "33C",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Terry L. Baker",
        "img": "https://mgaleg.maryland.gov/2023RS/images/baker04.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/baker04",
        "party": "R",
        "district": "1C",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "N"
        },
        "2023 Score": "30%",
        "Life time Score": "30%"
      }, 
      {
        "name": "Ben Barnes",
        "img": "https://mgaleg.maryland.gov/2023RS/images/barnes.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/barnes",
        "party": "D",
        "district": "21",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "95%"
      },
      {
        "name": "Darryl Barnes",
        "img": "https://mgaleg.maryland.gov/2023RS/images/bartlett02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/bartlett02",
        "party": "D",
        "district": "25",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "J. Sandy Bartlett",
        "img": "https://mgaleg.maryland.gov/2023RS/images/bartlett02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/bartlett02",
        "party": "D",
        "district": "32",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Kumar P. Barve",
        "img": "Placeholder",
"contact": "URL",
        "party": "D",
        "district": "17",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "90%"
      },
      {
        "name": "Harry Bhandari",
        "img": "https://mgaleg.maryland.gov/2023RS/images/bhandari01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/bhandari01",
        "party": "D",
        "district": "8",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Adrian Boafo",
        "img": "https://mgaleg.maryland.gov/2023RS/images/boafo01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/boafo01",
        "party": "D",
        "district": "23",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Christopher Eric Bouchat",
        "img": "https://mgaleg.maryland.gov/2023RS/images/bouchat01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/bouchat01",
        "party": "R",
        "district": "5",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "40%",
        "Life time Score": "40%"
      }, 
      {
        "name": "Regina T. Boyce",
        "img": "https://mgaleg.maryland.gov/2023RS/images/boyce01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/boyce01",
        "party": "D",
        "district": "43A",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Tony Bridges",
        "img": "Placeholder",
"contact": "URL",
        "party": "D",
        "district": "41",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Jason Buckel",
        "img": "https://mgaleg.maryland.gov/2023RS/images/buckel01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/buckel01",
        "party": "R",
        "district": "1B",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "15%"
      },
      {
        "name": "Jon S. Cardin",
        "img": "https://mgaleg.maryland.gov/2023RS/images/cardin01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/cardin01",
        "party": "D",
        "district": "11B",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Mark Chang",
        "img": "https://mgaleg.maryland.gov/2023RS/images/chang01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/chang01",
        "party": "D",
        "district": "32",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Lorig Charkoudian",
        "img": "https://mgaleg.maryland.gov/2023RS/images/charkoudian01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/charkoudian01",
        "party": "D",
        "district": "20",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Nick Charles",
        "img": "https://mgaleg.maryland.gov/2023RS/images/charles01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/charles01",
        "party": "D",
        "district": "25",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "N",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "90%",
        "Life time Score": "94%"
      },
      {
        "name": "Brian Chisholm",
        "img": "https://mgaleg.maryland.gov/2023RS/images/chisholm01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/chisholm01",
        "party": "R",
        "district": "31",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "16%"
      },
      {
        "name": "Barrie Ciliberti",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ciliberti01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ciliberti01",
        "party": "R",
        "district": "4",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "N",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "24%"
      },
      {
        "name": "Luke Clippinger",
        "img": "https://mgaleg.maryland.gov/2023RS/images/clippinger.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/clippinger",
        "party": "D",
        "district": "46",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Frank M. Conaway, Jr.",
        "img": "https://mgaleg.maryland.gov/2023RS/images/conaway.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/conaway",
        "party": "D",
        "district": "40",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "89%"
      },
      {
        "name": "Brian Crosby",
        "img": "https://mgaleg.maryland.gov/2023RS/images/crosby01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/crosby01",
        "party": "D",
        "district": "29B",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "N",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "N",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "80%",
        "Life time Score": "90%"
      },
      {
        "name": "Charlotte Crutchfield",
        "img": "https://mgaleg.maryland.gov/2023RS/images/crutchfield01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/crutchfield01",
        "party": "D",
        "district": "19",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Bonnie Cullison",
        "img": "https://mgaleg.maryland.gov/2023RS/images/cullison.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/cullison",
        "party": "D",
        "district": "19",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "99%"
      },
      {
        "name": "Debra Davis",
        "img": "https://mgaleg.maryland.gov/2023RS/images/davis02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/davis02",
        "party": "D",
        "district": "28",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Eric Ebersole",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ebersole01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ebersole01",
        "party": "D",
        "district": "44A",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "N",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "90%",
        "Life time Score": "96%"
      },
      {
        "name": "Mark Edelson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/edelson01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/edelson01",
        "party": "D",
        "district": "46",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Elizabeth Embry",
        "img": "https://mgaleg.maryland.gov/2023RS/images/embry01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/embry01",
        "party": "D",
        "district": "43A",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Kris Fair",
        "img": "https://mgaleg.maryland.gov/2023RS/images/fair01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/fair01",
        "party": "D",
        "district": "3",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Jessica Feldmark",
        "img": "https://mgaleg.maryland.gov/2023RS/images/feldmark01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/feldmark01",
        "party": "D",
        "district": "12A",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Diana M. Fennell",
        "img": "https://mgaleg.maryland.gov/2023RS/images/fennell01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/fennell01",
        "party": "D",
        "district": "47A",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Mark Fisher",
        "img": "https://mgaleg.maryland.gov/2023RS/images/fisher.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/fisher",
        "party": "R",
        "district": "27C",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "N",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "-",
          "Forest Conservation Act": "N"
        },
        "2023 Score": "0%",
        "Life time Score": "8%"
      },
      {
        "name": "Linda Foley",
        "img": "https://mgaleg.maryland.gov/2023RS/images/foley01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/foley01",
        "party": "D",
        "district": "15",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Catherine M. Forbes",
        "img": "https://mgaleg.maryland.gov/2023RS/images/forbes01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/forbes01",
        "party": "D",
        "district": "43B",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "David Fraser-Hidalgo",
        "img": "https://mgaleg.maryland.gov/2023RS/images/fraser01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/fraser01",
        "party": "D",
        "district": "15",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Jeff Ghrist",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ghrist01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ghrist01",
        "party": "R",
        "district": "36",
        "committee": "APP",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "N",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "18%"
      },
      {
        "name": "Robin Grammar",
        "img": "https://mgaleg.maryland.gov/2023RS/images/grammer01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/grammer01",
        "party": "R",
        "district": "6",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "-",
          "Forest Conservation Act": "-"
        },
        "2023 Score": "0%",
        "Life time Score": "14%"
      },
      {
        "name": "Mike Griffith",
        "img": "https://mgaleg.maryland.gov/2023RS/images/griffith02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/griffith02",
        "party": "R",
        "district": "35A",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "34%"
      },
      {
        "name": "Brooke Grossman",
        "img": "https://mgaleg.maryland.gov/2023RS/images/grossman01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/grossman01",
        "party": "D",
        "district": "2B",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Michele Guyton",
        "img": "https://mgaleg.maryland.gov/2023RS/images/guyton01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/guyton01",
        "party": "D",
        "district": "42B",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "E",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "E",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Pam Lanman Guzzone",
        "img": "https://mgaleg.maryland.gov/2023RS/images/guzzone01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/guzzone01",
        "party": "D",
        "district": "13",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Kevin Harris",
        "img": "https://mgaleg.maryland.gov/2023RS/images/harris02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/harris02",
        "party": "D",
        "district": "27A",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Andrea Harrison",
        "img": "https://mgaleg.maryland.gov/2023RS/images/harrison01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/harrison01",
        "party": "D",
        "district": "24",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Wayne Hartman",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hartman01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hartman01",
        "party": "R",
        "district": "38C",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "11%"
      },
      {
        "name": "Anne Healey",
        "img": "https://mgaleg.maryland.gov/2023RS/images/healey.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/healey",
        "party": "D",
        "district": "22",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "-",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "90%",
        "Life time Score": "93%"
      },
      {
        "name": "Shaneka Henson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/henson01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/henson01",
        "party": "D",
        "district": "30A",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "Terri Hill",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hill02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hill02",
        "party": "D",
        "district": "12A",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Jim Hinebaugh, Jr.",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hill02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hinebaugh01",
        "party": "R",
        "district": "1A",
        "committee": "APP",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "E",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "22%",
        "Life time Score": "22%"
      },
      {
        "name": "Marvin E. Holmes, Jr.",
        "img": "https://mgaleg.maryland.gov/2023RS/images/holmes.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/holmes",
        "party": "D",
        "district": "23",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "92%"
      },
      {
        "name": "Kevin Hornberger",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hornberger01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hornberger01",
        "party": "R",
        "district": "35B",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "E",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "44%",
        "Life time Score": "47%"
      },
      {
        "name": "Seth Howard",
        "img": "https://mgaleg.maryland.gov/2023RS/images/howard01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/howard01",
        "party": "R",
        "district": "30B",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "N",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "N",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "32%"
      },
      {
        "name": "Thomas S. Hutchinson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/hutchinson01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/hutchinson01",
        "party": "R",
        "district": "37B",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "20%"
      },
      {
        "name": "Julian Ivey",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ivey01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ivey01",
        "party": "D",
        "district": "47A",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Carl Jackson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/jackson02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/jackson02",
        "party": "D",
        "district": "8",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "N",
          "Maryland the Beautiful": "N",
          "Forest Conservation Act": "E"
        },
        "2023 Score": "80%",
        "Life time Score": "89%"
      },
      {
        "name": "Jay Jacobs",
        "img": "https://mgaleg.maryland.gov/2023RS/images/jacobs%20j.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/jacobs%20j",
        "party": "R",
        "district": "36",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "40%",
        "Life time Score": "28%"
      },
      {
        "name": "Andre V. Johnson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/johnson02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/johnson02",
        "party": "D",
        "district": "34A",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Steve Johnson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/johnson01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/johnson01",
        "party": "D",
        "district": "34A",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Adrienne A. Jones",
        "img": "https://mgaleg.maryland.gov/2023RS/images/jones.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/jones",
        "party": "D",
        "district": "10",
        "committee": "PRE",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "Dana Jones",
        "img": "https://mgaleg.maryland.gov/2023RS/images/jones01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/jones01",
        "party": "D",
        "district": "30A",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Anne R. Kaiser",
        "img": "https://mgaleg.maryland.gov/2023RS/images/kaiser.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/kaiser",
        "party": "D",
        "district": "14",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "94%"
      },
      {
        "name": "Aaron M. Kaufman",
        "img": "https://mgaleg.maryland.gov/2023RS/images/kaufman01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/kaufman01",
        "party": "D",
        "district": "18",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "90%"
      },
      {
        "name": "Ken Kerr",
        "img": "https://mgaleg.maryland.gov/2023RS/images/kerr01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/kerr01",
        "party": "D",
        "district": "3",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Nicholas Kipke",
        "img": "https://mgaleg.maryland.gov/2023RS/images/kipke.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/kipke",
        "party": "R",
        "district": "31",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "E",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "22%",
        "Life time Score": "43%"
      },
      {
        "name": "Marc Korman",
        "img": "https://mgaleg.maryland.gov/2023RS/images/korman01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/korman01",
        "party": "D",
        "district": "16",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Mary Lehman",
        "img": "https://mgaleg.maryland.gov/2023RS/images/lehman01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/lehman01",
        "party": "D",
        "district": "21",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Jazz Lewis",
        "img": "https://mgaleg.maryland.gov/2023RS/images/lewis02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/lewis02",
        "party": "D",
        "district": "24",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "Robbyn Lewis",
        "img": "https://mgaleg.maryland.gov/2023RS/images/lewis01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/lewis01",
        "party": "D",
        "district": "46",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "98%"
      },
      {
        "name": "Bob Long",
        "img": "https://mgaleg.maryland.gov/2023RS/images/long01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/long01",
        "party": "R",
        "district": "6",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "30%"
      },
      {
        "name": "Jeffrie Long",
        "img": "https://mgaleg.maryland.gov/2023RS/images/long02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/long02",
        "party": "D",
        "district": "27B",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "20%"
      },
      {
        "name": "Lesley J. Lopez",
        "img": "https://mgaleg.maryland.gov/2023RS/images/lopez01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/lopez01",
        "party": "D",
        "district": "39",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "95%"
      },
      {
        "name": "Sara Love",
        "img": "https://mgaleg.maryland.gov/2023RS/images/love01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/love01",
        "party": "D",
        "district": "16",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Nino Mangione",
        "img": "https://mgaleg.maryland.gov/2023RS/images/mangione01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/mangione01",
        "party": "R",
        "district": "42A",
        "committee": "APP",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "E",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "-",
          "Forest Conservation Act": "-"
        },
        "2023 Score": "0%",
        "Life time Score": "5%"
      },
      {
        "name": "Ashanti Martinez",
        "img": "https://mgaleg.maryland.gov/2023RS/images/martinez01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/martinez01",
        "party": "D",
        "district": "22",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Aletheia McCaskill",
        "img": "https://mgaleg.maryland.gov/2023RS/images/mccaskill01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/mccaskill01",
        "party": "D",
        "district": "44B",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Susan C. McComas",
        "img": "https://mgaleg.maryland.gov/2023RS/images/mccomas.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/mccomas",
        "party": "R",
        "district": "34B",
        "committee": "APP",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "26%"
      },
      {
        "name": "Ric Metzgar",
        "img": "https://mgaleg.maryland.gov/2023RS/images/metzgar01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/metzgar01",
        "party": "R",
        "district": "6",
        "committee": "APP",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "40%",
        "Life time Score": "24%"
      },
      {
        "name": "April Miller",
        "img": "https://mgaleg.maryland.gov/2023RS/images/miller03.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/miller03",
        "party": "R",
        "district": "4",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "20%"
      },
      {
        "name": "Bernice Mireku-North",
        "img": "https://mgaleg.maryland.gov/2023RS/images/mireku01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/mireku01",
        "party": "D",
        "district": "14",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "David Moon",
        "img": "https://mgaleg.maryland.gov/2023RS/images/moon01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/moon01",
        "party": "D",
        "district": "20",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Matt Morgan",
        "img": "https://mgaleg.maryland.gov/2023RS/images/morgan02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/morgan02",
        "party": "R",
        "district": "29A",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "14%"
      },
      {
        "name": "Todd Morgan",
        "img": "https://mgaleg.maryland.gov/2023RS/images/morgan03.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/morgan03",
        "party": "R",
        "district": "29C",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "30%"
      },
      {
        "name": "Rachel Munoz",
        "img": "https://mgaleg.maryland.gov/2023RS/images/munoz01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/munoz01",
        "party": "R",
        "district": "31",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "21%"
      },
      {
        "name": "Ryan Nawrocki",
        "img": "https://mgaleg.maryland.gov/2023RS/images/nawrocki01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/nawrocki01",
        "party": "R",
        "district": "7A",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "E",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "22%",
        "Life time Score": "22%"
      },
      {
        "name": "Charles E. Otto, III",
        "img": "https://mgaleg.maryland.gov/2023RS/images/otto.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/otto",
        "party": "R",
        "district": "38A",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "40%",
        "Life time Score": "26%"
      },
      {
        "name": "Julie Palokovich Carr",
        "img": "https://mgaleg.maryland.gov/2023RS/images/palakovich01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/palakovich01",
        "party": "D",
        "district": "17",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Cheryl E. Pasteur",
        "img": "https://mgaleg.maryland.gov/2023RS/images/pasteur01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/pasteur01",
        "party": "",
        "district": "",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Edith J. Patterson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/patterson02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/patterson02",
        "party": "D",
        "district": "28",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "Joseline Pena-Melnyk",
        "img": "https://mgaleg.maryland.gov/2023RS/images/pena.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/pena",
        "party": "D",
        "district": "21",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "N. Scott Phillips",
        "img": "https://mgaleg.maryland.gov/2023RS/images/phillips02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/phillips02",
        "party": "D",
        "district": "10",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Jesse Pippy",
        "img": "https://mgaleg.maryland.gov/2023RS/images/pippy01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/pippy01",
        "party": "R",
        "district": "4",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "16%"
      },
      {
        "name": "Andrew Pruski",
        "img": "https://mgaleg.maryland.gov/2023RS/images/pruski01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/pruski01",
        "party": "R",
        "district": "33A",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Lily Qi",
        "img": "https://mgaleg.maryland.gov/2023RS/images/qi01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/qi01",
        "party": "D",
        "district": "15",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Pamela Queen",
        "img": "https://mgaleg.maryland.gov/2023RS/images/queen01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/queen01",
        "party": "D",
        "district": "14",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "E",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "E"
        },
        "2023 Score": "89%",
        "Life time Score": "94%"
      },
      {
        "name": "Teresa Reilly",
        "img": "https://mgaleg.maryland.gov/2023RS/images/reilly01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/reilly01",
        "party": "R",
        "district": "35A",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "26%"
      },
      {
        "name": "Kirill Reznik",
        "img": "Placeholder",
"contact": "URL",
        "party": "D",
        "district": "39",
        "committee": "APP",
        "votes": {
          "Transit Equity": "E",
          "Comprehensive Flood Management": "E",
          "Greenspace Equity": "+",
          "Offshore Wind": "E",
          "LMI Energy Efficiency": "E",
          "Community Solar": "E",
          "Clean Trucks Act": "E",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "E",
          "Forest Conservation Act": "E"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Mike Rogers",
        "img": "https://mgaleg.maryland.gov/2023RS/images/rogers01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/rogers01",
        "party": "D",
        "district": "32",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "April Rose",
        "img": "https://mgaleg.maryland.gov/2023RS/images/rose01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/rose01",
        "party": "R",
        "district": "5",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "16%"
      },
      {
        "name": "Samuel I. \"Sandy\" Rosenberg",
        "img": "https://mgaleg.maryland.gov/2023RS/images/rosenberg.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/rosenberg",
        "party": "D",
        "district": "41",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "90%"
      },
      {
        "name": "Sheila Ruth",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ruth01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ruth01",
        "party": "D",
        "district": "44B",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Sheree Sample-Hughes",
        "img": "https://mgaleg.maryland.gov/2023RS/images/sample01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/sample01",
        "party": "D",
        "district": "37A",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "E",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "81%"
      },
      {
        "name": "Stewart Schmidt, Jr.",
        "img": "https://mgaleg.maryland.gov/2023RS/images/schmidt01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/schmidt01",
        "party": "R",
        "district": "33B",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "30%"
      },
      {
        "name": "Emily Shetty",
        "img": "https://mgaleg.maryland.gov/2023RS/images/shetty01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/shetty01",
        "party": "D",
        "district": "18",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Gary Simmons",
        "img": "https://mgaleg.maryland.gov/2023RS/images/simmons01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/simmons01",
        "party": "D",
        "district": "12B",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "E",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "E",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Karen Simpson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/simpson01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/simpson01",
        "party": "D",
        "district": "3",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Stephanie Smith",
        "img": "https://mgaleg.maryland.gov/2023RS/images/smith03.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/smith03",
        "party": "D",
        "district": "45",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Jared Solomon",
        "img": "https://mgaleg.maryland.gov/2023RS/images/solomon01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/solomon01",
        "party": "D",
        "district": "18",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Dana Stein",
        "img": "https://mgaleg.maryland.gov/2023RS/images/stein.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/stein",
        "party": "D",
        "district": "11B",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "94%"
      },
      {
        "name": "Vaughn Stewart",
        "img": "https://mgaleg.maryland.gov/2023RS/images/stewart01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/stewart01",
        "party": "D",
        "district": "19",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Joshua J. Stonko",
        "img": "https://mgaleg.maryland.gov/2023RS/images/stonko01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/stonko01",
        "party": "R",
        "district": "42C",
        "committee": "APP",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "30%"
      },
      {
        "name": "Kathy Szeliga",
        "img": "https://mgaleg.maryland.gov/2023RS/images/szeliga.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/szeliga",
        "party": "R",
        "district": "7A",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "20%",
        "Life time Score": "20%"
      },
      {
        "name": "Deni Taveras",
        "img": "https://mgaleg.maryland.gov/2023RS/images/taveras01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/taveras01",
        "party": "D",
        "district": "47B",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Kym Taylor",
        "img": "https://mgaleg.maryland.gov/2023RS/images/taylor03.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/taylor03",
        "party": "D",
        "district": "23",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Jen Terrasa",
        "img": "https://mgaleg.maryland.gov/2023RS/images/terrasa01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/terrasa01",
        "party": "D",
        "district": "13",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Karen Toles",
        "img": "https://mgaleg.maryland.gov/2023RS/images/toles01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/toles01",
        "party": "D",
        "district": "25",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Chris Tomlinson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/tomlinson01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/tomlinson01",
        "party": "R",
        "district": "5",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "+",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "30%",
        "Life time Score": "30%"
      },
      {
        "name": "Veronica Turner",
        "img": "https://mgaleg.maryland.gov/2023RS/images/turner01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/turner01",
        "party": "D",
        "district": "26",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "94%"
      },
      {
        "name": "Kriselda Valderrama",
        "img": "https://mgaleg.maryland.gov/2023RS/images/valderrama.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/valderrama",
        "party": "D",
        "district": "26",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "93%"
      },
      {
        "name": "William Valentine",
        "img": "https://mgaleg.maryland.gov/2023RS/images/valentine01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/valentine01",
        "party": "R",
        "district": "2A",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "-",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "10%",
        "Life time Score": "10%"
      },
      {
        "name": "Joe Vogel",
        "img": "https://mgaleg.maryland.gov/2023RS/images/vogel01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/vogel01",
        "party": "D",
        "district": "17",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Courtney Watson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/watson02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/watson02",
        "party": "D",
        "district": "9B",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Melissa Wells",
        "img": "https://mgaleg.maryland.gov/2023RS/images/wells02.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/wells02",
        "party": "D",
        "district": "40",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "97%"
      },
      {
        "name": "Jennifer White",
        "img": "https://mgaleg.maryland.gov/2023RS/images/white01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/white01",
        "party": "D",
        "district": "10",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Jheanelle Wilkins",
        "img": "https://mgaleg.maryland.gov/2023RS/images/wilkins01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/wilkins01",
        "party": "D",
        "district": "20",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Nicole Williams",
        "img": "https://mgaleg.maryland.gov/2023RS/images/williams01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/williams01",
        "party": "D",
        "district": "22",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "E",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "96%"
      },
      {
        "name": "C.T. Wilson",
        "img": "https://mgaleg.maryland.gov/2023RS/images/wilson.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/wilson",
        "party": "D",
        "district": "28",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "91%"
      },
      {
        "name": "William Wivell",
        "img": "https://mgaleg.maryland.gov/2023RS/images/wivell01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/wivell01",
        "party": "R",
        "district": "2A",
        "committee": "ECM",
        "votes": {
          "Transit Equity": "-",
          "Comprehensive Flood Management": "-",
          "Greenspace Equity": "-",
          "Offshore Wind": "-",
          "LMI Energy Efficiency": "-",
          "Community Solar": "-",
          "Clean Trucks Act": "-",
          "Clean Transportation and Energy": "-",
          "Maryland the Beautiful": "-",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "10%",
        "Life time Score": "21%"
      },
      {
        "name": "Sarah Wolek",
        "img": "https://mgaleg.maryland.gov/2023RS/images/wolek01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/wolek01",
        "party": "D",
        "district": "16",
        "committee": "APP",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "E",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "E",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Jamila Woods",
        "img": "https://mgaleg.maryland.gov/2023RS/images/woods01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/woods01",
        "party": "D",
        "district": "26",
        "committee": "HGO",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "N",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "E"
        },
        "2023 Score": "90%",
        "Life time Score": "90%"
      },
      {
        "name": "Chao Wu",
        "img": "https://mgaleg.maryland.gov/2023RS/images/wu01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/wu01",
        "party": "D",
        "district": "9A",
        "committee": "WAM",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "N",
          "Maryland the Beautiful": "90%",
          "Forest Conservation Act": "90%"
        },
        "2023 Score": "90%",
        "Life time Score": "90%"
      },
      {
        "name": "Caylin Young",
        "img": "https://mgaleg.maryland.gov/2023RS/images/young05.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/young05",
        "party": "D",
        "district": "45",
        "committee": "JUD",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      },
      {
        "name": "Natalie Ziegler",
        "img": "https://mgaleg.maryland.gov/2023RS/images/ziegler01.jpg",
"contact": "https://mgaleg.maryland.gov/mgawebsite/Members/Details/ziegler01",
        "party": "D",
        "district": "9A",
        "committee": "ENT",
        "votes": {
          "Transit Equity": "+",
          "Comprehensive Flood Management": "+",
          "Greenspace Equity": "+",
          "Offshore Wind": "+",
          "LMI Energy Efficiency": "+",
          "Community Solar": "+",
          "Clean Trucks Act": "+",
          "Clean Transportation and Energy": "+",
          "Maryland the Beautiful": "+",
          "Forest Conservation Act": "+"
        },
        "2023 Score": "100%",
        "Life time Score": "100%"
      }





  ]
  
export default delegateData;
